import { createGlobalStyle } from "styled-components";

export const BootstrapOverrides = createGlobalStyle`
  html {
    height: 100%;
  }
  body {
    min-height: 100%;
    height: 100%;
    font-family: "Poppins", sans-serif;
  }
  #root {
    height: 100%;
    color: #2E3862;
  }
  .btn {
    border-radius: 24px;
    font-size: 13px;
    outline: none;
    border-color: transparent;
  }
  .btn-primary {
    border-color: transparent;
    background-color: ${({ theme }) => theme.buttonColor};
    &:hover {
      border-color: transparent;
      background-color: ${({ theme }) => theme.buttonColorHover};
    }
    color: #ffffff;
  }
  .btn-light {
    border-color: ${({ theme }) => theme.buttonLightBorder};
  }
  .btn-danger {
    background-color: #f05050;
    border-color: #f04b4b;
  }
  .sectionAccordion {
    font-size: 16px !important;
  }
  .withoutMarginPadding {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .checkboxWeight {
    label.needsclick {
      font-weight: 600 !important;
    }
  }
  .witadmin-bs3 legend {
    margin-bottom: 20px;
  }
  .witadmin-bs3 form fieldset {
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .closeButtonInside{
    .react-datepicker__input-container {
      width: 300px;
    }
  }
  .dx-g-bs4-column-chooser-checkbox {
  margin-right: 10px;
  }

.dx-g-bs4-table-sticky { 
  z-index: 1 !important;
}
`;
